import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {  
  error: false,
  success:false,
  loading:false,
  loaded:false,
  advancedSecurity:null,

};
const resetAdvancedSecurityState = (state, action) => {
  return updateObject(state, initialState)
}
const getAdvancedSecurityStart = (state, action) => {
  return updateObject(state, {
    loading:true,
    loaded:false,
    error :false,
    success: false
  });
};

const setAdvancedSecuritySuccess = (state, action) => {
  return updateObject(state, {
    error :false,
    success: true,
    loading:false,
    loaded:true,
  });
};

const setAdvancedSecurityFailed = (state, action) => { 
  
  return updateObject(state, {
    error: true,
    success:false,
    loading:false,
    loaded:true,

  });
};

const setAdvancedSecurity = (state, action) => {
  let advancedSecurity = Object.assign({}, action.advancedSecurity);
  return updateObject(state, {
    advancedSecurity: advancedSecurity,
    loaded:true,
    loading:false
  });
};



const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ADVANCED_SECURITY_START:
      return getAdvancedSecurityStart(state, action);
    case actionTypes.SET_ADVANCED_SECURITY_SUCCESS:
      return setAdvancedSecuritySuccess(state, action);
    case actionTypes.SET_ADVANCED_SECURITY_FAILED:
      return setAdvancedSecurityFailed(state, action);
    case actionTypes.SET_ADVANCED_SECURITY:
      return setAdvancedSecurity(state, action);
    default:
      return state;
  }
};

export default reducer;
